/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type {
  ApplyChannelData, CalcPlanListData, LoanUsageOption, RemoteContract, ProductCapitalItem,
} from '@/api/apply-product/types';
import type { ContractItem } from '@/ContractConfig';
import { getAbTestContract } from '@/api/contract';
import CreatedIframe from '@/mixins/create-iframe';
import { Popup } from 'vant';
import { Toast, Tabs, TabItem } from '@hb/coffee';
import ForceReadBtn, { ButtonStatusEnum, ButtonTypeEnum } from '@/components/force-read-btn';
import { Contract, ContractSceneTypeEnum } from '@/api/contract/types';
import {
  Component, Mixins, Model, Vue, Watch,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { VueClass } from 'vue-class-component/lib/declarations';
import FinanceBusiness from '@/mixins/finance-business';
import { shouldShowPartialLoanTip } from '../../utils/partial-loan';
import style from './index.module.scss';

const ApplyProductStore = namespace('applyProduct');
const HomeStore = namespace('home');

@Component({
  name: 'WithdrawalPopUp',
})
export default class WithdrawalPopUp extends Mixins(
  CreatedIframe,
  FinanceBusiness,
) {
  @Model('change', {
    type: Boolean,
  })
  isVisiblePopup!: boolean;

  @ApplyProductStore.State amount!: string;

  @ApplyProductStore.State usage!: LoanUsageOption;

  @ApplyProductStore.State usageList!: LoanUsageOption[];

  @ApplyProductStore.State channel!: ApplyChannelData;


  @ApplyProductStore.State contracts!: (ContractItem | RemoteContract)[];

  @ApplyProductStore.State creditContracts!: Contract[];

  @ApplyProductStore.State planListData!: CalcPlanListData;

  @ApplyProductStore.State isUpgradeChecked!: boolean;

  @ApplyProductStore.Action $updateState!: (data: Dictionary) => void;

  @ApplyProductStore.Action getAutarkyAgreements!: () => Promise<void>;

  @HomeStore.Getter isExperimentAB!: boolean;

  private isWithdrawalPopup = false

  private currentUsageIndex = 0

  private currentDisplayContractIndex = 0

  private currentScrollHeight = 0

  private currentTabBaroffsetTop = 0

  // 是否需要倒计时
  private needCountDownNum = false;

  /** 是否勾选 提现&授信升级 */
  private checked = false;

  /** 本地合同需要渲染的地方 */
  private clazz: VueClass<Vue> | undefined = undefined;

  @Watch('isVisiblePopup')
  private onChangeProps(val: boolean, oldValue: boolean) {
    if (oldValue === val) return;
    if (val) {
      /** 协议重新打开协议弹窗时重置勾选状态，此时外层获取协议时已将协议数据重置，故此处不需要删除授信协议 */
      this.checked = false;
      this.$updateState({
        isUpgradeChecked: false,
      });
      /** 协议展示时，命中自营实验组，上报埋点 */
      if (this.isExperimentAB) {
        this.$ubtModuleExposeNew('finance_loan_agreement_upgrade');
      }
      this.$nextTick(() => {
        /** 需要展示协议 tab 时，再处理 */
        if (this.contractName) {
          const ele = document.getElementById('currentDom')!;
          const testEle = document.getElementById('currentTabbar')!;
          ele.addEventListener('scroll', () => {
            this.currentScrollHeight = ele.scrollTop;
          }, { passive: true });
          this.currentTabBaroffsetTop = testEle.offsetTop - 53;
        }


        // 默认选中第一项
        this.showType(0);
        this.$ubtModuleExposeNew(
          'finance_agreementClickFirst',
          {
            channelList: [{
              supplierCode: this.channel.productId,
              agreementName: this.contracts[0].name,
            }],
          },
        );
      });
    } else {
      this.currentDisplayContractIndex = 0;
      const ele = document.getElementById('currentDom')!;
      ele.scrollTo(0, 0);
    }
  }

  @Watch('channel', { immediate: true })
  private async hasChannel(val: ApplyChannelData) {
    if (val && val.productId) {
      // 请求协议页协议阅读限制,该提现协议模式下只有强制阅读限制
      const { forceRead } = await getAbTestContract(
        ContractSceneTypeEnum.apply, [this.channel.productId],
      );
      this.needCountDownNum = forceRead || false;
    }
  }

  // 显示格式化的金额
  private get showAmount(): string {
    return String(this.amount).replace(/(\d)(?=(?:\d{3})+($|\.))/g, '$1,');
  }

  private get contractName() {
    return this.contracts && this.contracts.length > 1;
  }

  private get getScrollVaule() {
    return this.currentScrollHeight > this.currentTabBaroffsetTop;
  }

  /** 是否投保模式 */
  private get isInsure() {
    return this.isVisiblePopup && this.planListData && this.planListData.insure;
  }

  /** 根据当前合同类型来选择渲染不同合同
   * @ index：当前点击的合同下标
   * @ clazz:当前本地文件类
   * @ 其他情况直接iframe嵌入文件展示
   */
  private showType(index: number) {
    this.clazz = undefined;
    const { clazz: classType } = this.contracts[index] as ContractItem || {};
    if (classType) {
      // 移除iframe展示
      this.removeIframe();
      this.clazz = classType;
    } else {
      this.createdIframe(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.contracts[index].url!,
        'currentIframe',
        'fatherIframe',
        style.iframeStyle,
      );
    }

    /** tab 位置切换 */
    this.currentDisplayContractIndex = index;
    // 新增协议tab点击埋点
    this.$ubtPageButtonNew(
      'finance_agreementClick',
      {
        agreementName: this.contracts[index].name,
        supplierCode: this.channel.productId,
      },
    );
    // 强制页面更新解决自动计算协议本地文件时，不显示问题
    this.$forceUpdate();
  }

  // 切换tab
  private onChangeTabs(index: number) {
    this.currentDisplayContractIndex = index;
    if (this.getScrollVaule) {
      const ele = document.getElementById('currentDom')!;
      ele.scrollTo(0, this.currentTabBaroffsetTop);
    }
    const contractBtn = document.getElementById(`contractTab${index}`) as HTMLElement;
    if (contractBtn) {
      contractBtn.scrollIntoView({ behavior: 'smooth' });
    }
    this.showType(index);
  }

  // 关闭
  private onClosedPopup() {
    this.$ubtPageButton(
      'finance_withdrawalAgreement_close',
      '产品',
      this.channel.productId,
    );

    this.$emit('close');
  }

  // 日常消费
  private onCheckUsing() {
    this.$ubtPageButton(
      '臻有钱_提现申请_选择提现用途',
      '产品',
      this.channel.productId,
    );
    this.isWithdrawalPopup = true;
  }

  // 选择提现用途项
  private onSelectName(usage: LoanUsageOption, index: number) {
    this.currentUsageIndex = index;
    this.$updateState({
      usage,
    });
    this.onBackCurrentDialog();
  }

  // 回退
  private onBackCurrentDialog() {
    this.isWithdrawalPopup = false;
  }

  private showContractName(name: string): string {
    if (!name) return '';
    return name.includes('《') ? name.replace('《', '').replace('》', '') : name;
  }

  private hideWithdrawalPopup() {
    this.$emit('change', false);
  }

  private exposeHandler() {
    // 弹窗显示时 新增弹窗expose 埋点
    this.$ubtModuleExpose(
      'finance_withdrawalAgreement',
      'commodityId',
      this.channel && this.channel.productId,
    );
  }

  private track(type:ButtonStatusEnum) {
    this.$ubtPageButtonNew('提现确认_同意确认提现', {
      flagType: 'commodityId',
      flagValue: this.channel.productId,
      extraType: 'buttonStatus',
      extraValue: type === ButtonStatusEnum.countDown ? 'countdownNotClick' : 'canClick',
      upgrade_expose: this.isExperimentAB ? 1 : 0,
      upgrade_check: this.checked ? 1 : 0,
    });
  }

  // 同意
  private onConfrim() {
    // 检测协议展示是否异常，防止极端情况协议弹窗未弹出时切换渠道导致的空白协议提交
    if (this.isContractDisplayAbnormal()) {
      Toast('协议展示异常，请关闭弹窗重新提交订单');
      return;
    }
    this.track(ButtonStatusEnum.avaliable);
    this.$emit('confirm', () => {
      /**
       * 延迟200ms关闭弹窗，避免提交订单接口还未展示loading，用户可以点击底部“提交”按钮，导致时序问题
       * 详细问题请阅：https://metis2.hellobike.cn/browse/SKXDZC-7140
       */
      setTimeout(() => {
        this.hideWithdrawalPopup();
      }, 200);
    });
  }

  /**
   * 检测协议展示是否异常，防止极端情况协议弹窗未弹出时切换渠道导致的空白协议提交
   */
  private isContractDisplayAbnormal(): boolean {
    // 检查是否存在有效的协议 - 所有协议都无效才返回true
    const hasValidContract = this.contracts.some(
      (contract) => contract.name && (
        ('clazz' in contract && contract.clazz) // 本地协议组件
        || ('url' in contract && contract.url) // 远程协议URL
      ),
    );

    if (!hasValidContract) {
      return true;
    }

    return false;
  }

  // 倒数计时点击上报埋点数据
  private onCountDown() {
    this.track(ButtonStatusEnum.countDown);
  }

  /** 投保 流程点击不投保 */
  private notGoInsure() {
    this.$ubtPageButton('finance_financeLoanApply_applyCheck_refuse');
    Toast({
      message: '当前暂不支持该类放款服务，请更换放款机构或回首页重新申请',
      duration: 3000,
      forbidClick: true,
      className: style.insuranceTips,
    });
  }

  /** 根据勾选状态更新协议数据&协议展示 */
  private changeContractsBasedOnCheck(checked:boolean) {
    if (checked) {
      /** 原始协议长度 */
      const oldContractsLength = this.contracts.length;
      /** 更新提现展示协议，需要加入8180授信一体化授信协议 */
      this.$updateState({
        contracts: this.contracts.concat(this.creditContracts),
      });

      this.$nextTick(() => {
        /** tab切换到授信协议 */
        this.onChangeTabs(oldContractsLength);
      });
    } else {
      /** 取消勾选以后，协议剔除授信协议 */
      /** 原始提现协议长度 */
      const OriginContactLength = this.contracts.length - this.creditContracts.length;
      this.$updateState({
        contracts: this.contracts.slice(0, OriginContactLength),
      });
      /** tab 切换到第一个 */
      this.onChangeTabs(0);
    }
  }

  /** 切换勾选状态-授信自营 B 勾选 */
  private async switchCheck(val: boolean) {
    this.checked = val;

    try {
      /** 勾选的时候&未获取到8180协议时，去获取自营 B 协议 */
      if (this.checked && !this.creditContracts.length) {
        // 防止外层未接口报错未获取到8180授信协议，此处需再次获取
        await this.getAutarkyAgreements();
      }
      /** 根据勾选状态更新协议 */
      this.changeContractsBasedOnCheck(this.checked);
      /** 更新勾选状态 */
      this.$updateState({
        isUpgradeChecked: this.checked,
      });
      // 勾选埋点
      this.$ubtPageButtonNew('finance_loan_agreement_upgrade', {
        check: this.checked ? 1 : 0,
      });
    } catch (error) {
      this.checked = !val;
      // eslint-disable-next-line no-console
      console.error('获取自营 B 协议失败', error);
    }
  }

  private render() {
    const AgreementComponent = this.clazz;
    return (
      <div class={style.WithdrawalPopUp}>
        <Popup
          v-model={this.isVisiblePopup}
          class={style.popupRadius}
          position='bottom'
          closeOnClickOverlay={false}
        >
          <section class={style.mainContent}>
            <div class={style.navContent}>
              <div class={style.title}>
                <span>确认提现</span>
                <span class={style.closed} onClick={this.onClosedPopup.bind(this)}></span>
              </div>

              <div class={style.contractPart} id={'currentDom'}>
              <div class={style.contentScroll}>
                <div class={style.contentDetails}>
                  <div class={style.tipsTitle}>
                    <div class={style.subTitle}>提现金额</div>
                    <div class={style.moneyText}>
                      <span>¥</span>
                      <span class={style.moneyAmount}>{this.showAmount ? `${this.showAmount}` : ''}</span>
                    </div>

                    <div class={style.contractText}>
                      <div class={style.partialLoanTip}>
                        {shouldShowPartialLoanTip(this.channel) ? (
                          <span class={style.partialText}>实际金额以放款为准,</span>
                        ) : (
                          <span class={style.text}>请不要去投资房产与炒股,</span>
                        )}
                        <span class={style.text}>我承诺以上收款用于</span>
                      </div>
                      <div class={style.contractName}>
                        <span onClick={this.onCheckUsing.bind(this)}>{(this.usage && this.usage.name) || '个人日常消费'}</span>
                        <span></span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class={[style.contentBar, !this.contractName && style.oneContracts]}>
                  <div class={style.tabBarBox} v-show={this.contractName}>
                    <div
                      id='currentTabbar'
                      class={[
                        style.tabsList,
                        this.getScrollVaule && style.scrollTabTop,
                      ]}>
                        <div class={style.lineBg}></div>
                        {/** 针对勾选更新协议的情况下，使用key强制重新渲染 Tabs组件 */}
                        <Tabs
                          key={Date.now()}
                          size="small"
                          scrollable={true}
                          activeIndex={this.currentDisplayContractIndex}
                          onChange={this.onChangeTabs.bind(this)}>
                            {this.contracts.map((item, index) => (
                              <TabItem
                                key={`contractTab${index}`}
                                title={this.showContractName(item.name)}
                                name={`contractTab${index}`}
                              />
                            ))}
                        </Tabs>
                    </div>
                  </div>
                  <div id='fatherIframe' class={style.iframeContent}>
                      {AgreementComponent && (
                        <div class={style.localWrapper}>
                          <AgreementComponent/>
                        </div>
                      )}
                  </div>
                </div>

                </div>

              </div>
            </div>


            <footer class={style.footer}>
              { this.isExperimentAB
              && <div class={style.experimentAB}>
                  <div class={style.abDes}>
                    <div class={style.des}><span class={style.desSpan}>升级新产品</span> 享受更高额度</div>
                    <div class={style.subDes}>您资质优秀，升级后有机会享受更高额度</div>
                  </div>
                  <div
                    class={style.checkBox}
                    onClick={this.switchCheck.bind(this, !this.checked)}
                  >
                    <div class={[
                      style.upgradeCheck,
                      this.checked ? style.checked : style.upgradeCheck,
                    ]}>
                    </div>
                    <div class={style.checkDes}>勾选可立即升级新产品</div>
                  </div>
              </div>
              }
              { this.isVisiblePopup
                && <ForceReadBtn
                    buttonType={ButtonTypeEnum.apply}
                    needCountDownNum={this.needCountDownNum}
                    insure = {this.planListData && this.planListData.insure}
                    onSubmit={this.onConfrim.bind(this)}
                    onCountDown={this.onCountDown.bind(this)}
                    onExposeHandler={this.exposeHandler.bind(this)}
                ></ForceReadBtn>
              }
              {this.isInsure
                && <div class={style.noInsurance}
                  onClick={this.notGoInsure.bind(this)}
                >不投保 无增信申请借款</div>
              }
            </footer>
          </section>

          {/* 日常消费提现 */}
         <div class={[style.usingPart, this.isWithdrawalPopup && style.transform]}>
           <div class={style.usageContent}>
            <div class={style.usingTitle}>
                <span>请选择提现用途</span>
                <span class={style.back} onClick={this.onBackCurrentDialog.bind(this)}></span>
              </div>

              <div class={style.selectUsage}>
                {
                  this.usageList.map((item, index) => (<div
                    class={[style.usingContent, 'Hairline', this.currentUsageIndex === index && style.active]}
                    key={item.code}
                    onClick={() => this.onSelectName(item, index)}>
                  <span>{item.name}</span>
                  <span class={style.right} v-show={this.currentUsageIndex === index }></span>
                </div>))
                }
              </div>

            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
